// // pages/GolfStatisticsDashboard.js
// import { useState, useEffect } from "react";
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   PieChart,
//   Pie,
//   Cell,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
// } from "recharts";
// import api from "../api/axiosInstance";
// import { toast } from "react-hot-toast";
// import { useNavigate } from "react-router-dom";

// const GolfStatisticsDashboard = () => {
//   const [summary, setSummary] = useState(null);
//   const [trends, setTrends] = useState(null);
//   const [insights, setInsights] = useState(null);
//   const [timeRange, setTimeRange] = useState(6); // months
//   const [activeTab, setActiveTab] = useState("overview");
//   const [loading, setLoading] = useState({
//     summary: true,
//     trends: true,
//     insights: true,
//   });

//   const navigate = useNavigate();

//   const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#8884D8"];

//   useEffect(() => {
//     fetchSummary();
//     fetchTrends(timeRange);
//     fetchInsights();
//   }, [timeRange]);

//   const fetchSummary = async () => {
//     try {
//       setLoading((prev) => ({ ...prev, summary: true }));
//       const response = await api.get("/golf-statistics/my-summary");
//       setSummary(response.data);
//     } catch (error) {
//       console.error("Error fetching summary:", error);
//       toast.error("Failed to load statistics summary");
//     } finally {
//       setLoading((prev) => ({ ...prev, summary: false }));
//     }
//   };

//   const fetchTrends = async (months) => {
//     try {
//       setLoading((prev) => ({ ...prev, trends: true }));
//       const response = await api.get(
//         `/golf-statistics/historical-trends/${months}`
//       );
//       setTrends(response.data);
//     } catch (error) {
//       console.error("Error fetching trends:", error);
//       toast.error("Failed to load trend data");
//     } finally {
//       setLoading((prev) => ({ ...prev, trends: false }));
//     }
//   };

//   const fetchInsights = async () => {
//     try {
//       setLoading((prev) => ({ ...prev, insights: true }));
//       const response = await api.get("/golf-statistics/performance-insights");
//       setInsights(response.data);
//     } catch (error) {
//       console.error("Error fetching insights:", error);
//       toast.error("Failed to load performance insights");
//     } finally {
//       setLoading((prev) => ({ ...prev, insights: false }));
//     }
//   };

//   // Prepare trend data for charts
//   const prepareTrendData = () => {
//     if (!trends) return [];

//     const months = Object.keys(trends.scoreTrend || {});
//     return months.map((month) => ({
//       name: month.substring(0, 3), // Short month name
//       score: trends.scoreTrend[month] || 0,
//       handicap: trends.handicapTrend[month] || 0,
//       fairways: trends.fairwaysTrend[month] || 0,
//       gir: trends.girTrend[month] || 0,
//       putts: trends.puttingTrend[month] || 0,
//     }));
//   };

//   // Prepare performance metrics data for bar chart
//   const preparePerformanceData = () => {
//     if (!trends) return [];

//     const months = Object.keys(trends.scoreTrend || {});
//     return months.map((month) => ({
//       name: month.substring(0, 3),
//       fairways: trends.fairwaysTrend[month] || 0,
//       gir: trends.girTrend[month] || 0,
//       putts: trends.puttingTrend[month] || 0,
//     }));
//   };

//   if (loading.summary) {
//     return (
//       <div className="min-h-screen bg-gray-100 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600 mx-auto"></div>
//           <p className="mt-4 text-gray-600">Loading golf statistics...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gray-100">
//       {/* Header */}
//       <header className="bg-white shadow-sm">
//         <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
//           <div className="flex justify-between items-center py-4">
//             <div>
//               <button
//                 onClick={() => navigate("/dashboard")}
//                 className="flex items-center text-gray-600 hover:text-gray-900 mb-2"
//               >
//                 <svg
//                   className="w-3 h-4 mr-1"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M15 19l-7-7 7-7"
//                   />
//                 </svg>
//                 Back to Dashboard
//               </button>
//               <h1 className="text-xl sm:text-2xl font-bold text-gray-900">
//                 Golf Statistics
//               </h1>
//               {/* <p className="text-sm sm:text-base text-gray-600">
//                 Track and analyze your golf performance
//               </p> */}
//             </div>
//           </div>
//         </div>
//       </header>

//       <main className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6 py-4 sm:py-6 lg:py-8">
//         {/* Summary Cards */}
//         <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 mb-6 sm:mb-8">
//           <div className="bg-white rounded-lg shadow p-4 sm:p-6">
//             <h3 className="text-sm sm:text-base font-semibold text-gray-700 mb-1 sm:mb-2">
//               Average Score
//             </h3>
//             <p className="text-2xl sm:text-3xl font-bold text-blue-600">
//               {summary?.averages?.scoring || "N/A"}
//             </p>
//           </div>

//           <div className="bg-white rounded-lg shadow p-4 sm:p-6">
//             <h3 className="text-sm sm:text-base font-semibold text-gray-700 mb-1 sm:mb-2">
//               Handicap Index
//             </h3>
//             <p className="text-2xl sm:text-3xl font-bold text-green-600">
//               {summary?.averages?.handicap || "N/A"}
//             </p>
//           </div>

//           <div className="bg-white rounded-lg shadow p-4 sm:p-6">
//             <h3 className="text-sm sm:text-base font-semibold text-gray-700 mb-1 sm:mb-2">
//               Total Rounds
//             </h3>
//             <p className="text-2xl sm:text-3xl font-bold text-purple-600">
//               {summary?.totalRounds || 0}
//             </p>
//           </div>

//           <div className="bg-white rounded-lg shadow p-4 sm:p-6">
//             <h3 className="text-sm sm:text-base font-semibold text-gray-700 mb-1 sm:mb-2">
//               Latest Round
//             </h3>
//             <p className="text-xl sm:text-2xl font-bold text-orange-600">
//               {summary?.latestRound?.score || "N/A"}
//             </p>
//             <p className="text-xs sm:text-sm text-gray-500 truncate">
//               {summary?.latestRound?.course}
//             </p>
//           </div>
//         </div>

//         {/* Navigation Tabs */}
//         <div className="mb-4 sm:mb-6">
//           <div className="border-b border-gray-200 overflow-x-auto">
//             <nav className="flex space-x-4 sm:space-x-8 min-w-max">
//               {["overview", "trends", "insights"].map((tab) => (
//                 <button
//                   key={tab}
//                   onClick={() => setActiveTab(tab)}
//                   className={`py-2 px-1 border-b-2 font-medium text-xs sm:text-sm capitalize whitespace-nowrap ${
//                     activeTab === tab
//                       ? "border-blue-500 text-blue-600"
//                       : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
//                   }`}
//                 >
//                   {tab}
//                 </button>
//               ))}
//             </nav>
//           </div>
//         </div>

//         {/* Tab Content */}
//         <div className="bg-white rounded-lg shadow p-4 sm:p-6">
//           {activeTab === "overview" && (
//             <OverviewTab summary={summary} loading={loading} COLORS={COLORS} />
//           )}
//           {activeTab === "trends" && (
//             <TrendsTab
//               trends={trends}
//               timeRange={timeRange}
//               setTimeRange={setTimeRange}
//               loading={loading}
//               COLORS={COLORS}
//               prepareTrendData={prepareTrendData}
//               preparePerformanceData={preparePerformanceData}
//             />
//           )}
//           {activeTab === "insights" && (
//             <InsightsTab
//               insights={insights}
//               loading={loading}
//               COLORS={COLORS}
//             />
//           )}
//         </div>
//       </main>
//     </div>
//   );
// };

// // Overview Tab Component
// const OverviewTab = ({ summary, loading, COLORS }) => {
//   if (loading.summary) {
//     return <div className="text-center py-6 sm:py-8">Loading overview...</div>;
//   }

//   if (!summary || summary.message) {
//     return (
//       <div className="text-center py-6 sm:py-8">
//         <p className="text-gray-500 text-sm sm:text-base">
//           No statistics available. Start by adding your first round!
//         </p>
//       </div>
//     );
//   }

//   const scoringDistribution =
//     summary.recentRounds && summary.recentRounds[0]
//       ? [
//           { name: "Eagles", value: summary.recentRounds[0].eagles || 0 },
//           { name: "Birdies", value: summary.recentRounds[0].birdies || 0 },
//           { name: "Pars", value: summary.recentRounds[0].pars || 0 },
//           { name: "Bogeys", value: summary.recentRounds[0].bogeys || 0 },
//           {
//             name: "Double Bogeys+",
//             value: summary.recentRounds[0].doubleBogeys || 0,
//           },
//         ]
//       : [];

//   // Prepare data for putting performance chart
//   const puttingData = summary.recentRounds
//     ? summary.recentRounds.map((round, index) => ({
//         name: `R${index + 1}`,
//         putts: round.totalPutts || 0,
//         score: round.totalScore || 0,
//       }))
//     : [];

//   return (
//     <div className="space-y-4 sm:space-y-6">
//       <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
//         Performance Overview
//       </h2>

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
//         {/* Scoring Distribution Pie Chart */}
//         <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
//           <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//             Scoring Distribution
//           </h3>
//           {scoringDistribution.length > 0 ? (
//             <ResponsiveContainer width="100%" height={250}>
//               <PieChart>
//                 <Pie
//                   data={scoringDistribution}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   label={({ name, percent }) =>
//                     `${name} ${(percent * 100).toFixed(0)}%`
//                   }
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {scoringDistribution.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={COLORS[index % COLORS.length]}
//                     />
//                   ))}
//                 </Pie>
//                 <Tooltip formatter={(value) => [`${value} shots`, "Count"]} />
//                 <Legend wrapperStyle={{ fontSize: "12px" }} />
//               </PieChart>
//             </ResponsiveContainer>
//           ) : (
//             <p className="text-gray-500 text-center py-6 sm:py-8 text-sm">
//               No scoring data available
//             </p>
//           )}
//         </div>

//         {/* Putting Performance Bar Chart */}
//         <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
//           <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//             Putting Performance
//           </h3>
//           {puttingData.length > 0 ? (
//             <ResponsiveContainer width="100%" height={250}>
//               <BarChart data={puttingData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" fontSize={12} />
//                 <YAxis fontSize={12} />
//                 <Tooltip />
//                 <Legend wrapperStyle={{ fontSize: "12px" }} />
//                 <Bar dataKey="putts" fill="#8884D8" name="Putts" />
//                 <Bar dataKey="score" fill="#FF8042" name="Score" />
//               </BarChart>
//             </ResponsiveContainer>
//           ) : (
//             <p className="text-gray-500 text-center py-6 sm:py-8 text-sm">
//               No putting data available
//             </p>
//           )}
//         </div>
//       </div>

//       {/* Recent Rounds */}
//       <div className="mt-4 sm:mt-6">
//         <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//           Recent Rounds
//         </h3>
//         {summary.recentRounds && summary.recentRounds.length > 0 ? (
//           <div className="space-y-2 sm:space-y-3">
//             {summary.recentRounds.map((round, index) => (
//               <div
//                 key={index}
//                 className="flex flex-col sm:flex-row sm:justify-between sm:items-center p-3 sm:p-4 bg-gray-50 rounded-lg border space-y-2 sm:space-y-0"
//               >
//                 <div className="flex-1">
//                   <p className="font-semibold text-base sm:text-lg truncate">
//                     {round.courseName}
//                   </p>
//                   <p className="text-xs sm:text-sm text-gray-500">
//                     {round.roundDate}
//                   </p>
//                 </div>
//                 <div className="text-left sm:text-right">
//                   <p className="text-xl sm:text-2xl font-bold text-blue-600">
//                     {round.totalScore}
//                   </p>
//                   <div className="flex flex-wrap gap-2 sm:gap-4 text-xs sm:text-sm text-gray-600 mt-1">
//                     <span>Hcp: {round.handicapIndex || "N/A"}</span>
//                     <span>Putts: {round.totalPutts || "N/A"}</span>
//                     {round.fairwaysHit && round.fairwaysPossible && (
//                       <span>
//                         FW:{" "}
//                         {(
//                           (round.fairwaysHit / round.fairwaysPossible) *
//                           100
//                         ).toFixed(0)}
//                         %
//                       </span>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <p className="text-gray-500 text-center py-6 sm:py-8 text-sm">
//             No recent rounds
//           </p>
//         )}
//       </div>
//     </div>
//   );
// };

// // Trends Tab Component
// const TrendsTab = ({
//   trends,
//   timeRange,
//   setTimeRange,
//   loading,
//   COLORS,
//   prepareTrendData,
//   preparePerformanceData,
// }) => {
//   const trendData = prepareTrendData();
//   const performanceData = preparePerformanceData();

//   if (loading.trends) {
//     return <div className="text-center py-6 sm:py-8">Loading trends...</div>;
//   }

//   return (
//     <div className="space-y-4 sm:space-y-6">
//       <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-0">
//         <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
//           Performance Trends
//         </h2>
//         <select
//           value={timeRange}
//           onChange={(e) => setTimeRange(parseInt(e.target.value))}
//           className="border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
//         >
//           <option value={3}>Last 3 Months</option>
//           <option value={6}>Last 6 Months</option>
//           <option value={12}>Last 12 Months</option>
//         </select>
//       </div>

//       {trendData.length > 0 ? (
//         <div className="space-y-6 sm:space-y-8">
//           {/* Score and Handicap Trends */}
//           <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
//             {/* Score Trend */}
//             <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
//               <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//                 Score Trend
//               </h3>
//               <ResponsiveContainer width="100%" height={250}>
//                 <LineChart data={trendData}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="name" fontSize={12} />
//                   <YAxis fontSize={12} />
//                   <Tooltip />
//                   <Legend wrapperStyle={{ fontSize: "12px" }} />
//                   <Line
//                     type="monotone"
//                     dataKey="score"
//                     stroke={COLORS[0]}
//                     strokeWidth={2}
//                     name="Avg Score"
//                     dot={{ fill: COLORS[0], strokeWidth: 2, r: 3 }}
//                     activeDot={{ r: 5, fill: COLORS[0] }}
//                   />
//                 </LineChart>
//               </ResponsiveContainer>
//             </div>

//             {/* Handicap Trend */}
//             <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
//               <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//                 Handicap Trend
//               </h3>
//               <ResponsiveContainer width="100%" height={250}>
//                 <LineChart data={trendData}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="name" fontSize={12} />
//                   <YAxis fontSize={12} />
//                   <Tooltip />
//                   <Legend wrapperStyle={{ fontSize: "12px" }} />
//                   <Line
//                     type="monotone"
//                     dataKey="handicap"
//                     stroke={COLORS[1]}
//                     strokeWidth={2}
//                     name="Handicap"
//                     dot={{ fill: COLORS[1], strokeWidth: 2, r: 3 }}
//                     activeDot={{ r: 5, fill: COLORS[1] }}
//                   />
//                 </LineChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           {/* Performance Metrics Bar Chart */}
//           <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
//             <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//               Performance Metrics
//             </h3>
//             <ResponsiveContainer width="100%" height={250}>
//               <BarChart data={performanceData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" fontSize={12} />
//                 <YAxis fontSize={12} />
//                 <Tooltip formatter={(value) => [`${value}%`, "Percentage"]} />
//                 <Legend wrapperStyle={{ fontSize: "12px" }} />
//                 <Bar
//                   dataKey="fairways"
//                   fill={COLORS[2]}
//                   name="Fairways %"
//                   radius={[2, 2, 0, 0]}
//                 />
//                 <Bar
//                   dataKey="gir"
//                   fill={COLORS[3]}
//                   name="GIR %"
//                   radius={[2, 2, 0, 0]}
//                 />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>

//           {/* Putting Trend */}
//           <div className="bg-gray-50 p-3 sm:p-4 rounded-lg">
//             <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//               Putting Trend
//             </h3>
//             <ResponsiveContainer width="100%" height={250}>
//               <LineChart data={trendData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" fontSize={12} />
//                 <YAxis fontSize={12} />
//                 <Tooltip />
//                 <Legend wrapperStyle={{ fontSize: "12px" }} />
//                 <Line
//                   type="monotone"
//                   dataKey="putts"
//                   stroke={COLORS[4]}
//                   strokeWidth={2}
//                   name="Avg Putts"
//                   dot={{ fill: COLORS[4], strokeWidth: 2, r: 3 }}
//                   activeDot={{ r: 5, fill: COLORS[4] }}
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       ) : (
//         <div className="text-center py-6 sm:py-8">
//           <p className="text-gray-500 text-sm sm:text-base">
//             No trend data available for the selected period
//           </p>
//         </div>
//       )}
//     </div>
//   );
// };

// // Insights Tab Component
// const InsightsTab = ({ insights, loading, COLORS }) => {
//   if (loading.insights) {
//     return <div className="text-center py-6 sm:py-8">Loading insights...</div>;
//   }

//   if (!insights || insights.message) {
//     return (
//       <div className="text-center py-6 sm:py-8">
//         <p className="text-gray-500 text-sm sm:text-base">
//           No insights available. Add more rounds to get performance insights.
//         </p>
//       </div>
//     );
//   }

//   // Prepare data for strengths/weaknesses chart
//   const strengthsData = insights.strengthsWeaknesses
//     ? Object.entries(insights.strengthsWeaknesses).map(
//         ([category, rating]) => ({
//           category:
//             category.length > 10 ? category.substring(0, 10) + "..." : category,
//           rating: rating === "Excellent" ? 100 : rating === "Good" ? 75 : 50,
//           color:
//             rating === "Excellent"
//               ? COLORS[1]
//               : rating === "Good"
//               ? COLORS[2]
//               : COLORS[3],
//         })
//       )
//     : [];

//   return (
//     <div className="space-y-4 sm:space-y-6">
//       <h2 className="text-xl sm:text-2xl font-bold text-gray-900">
//         Performance Insights
//       </h2>

//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
//         {/* Best & Worst Rounds */}
//         <div className="space-y-3 sm:space-y-4">
//           <h3 className="text-base sm:text-lg font-semibold">Round Analysis</h3>

//           {insights.bestRound && (
//             <div className="bg-green-50 p-3 sm:p-4 rounded-lg border border-green-200">
//               <h4 className="font-semibold text-green-800 text-sm sm:text-base">
//                 Best Round
//               </h4>
//               <p className="text-xl sm:text-2xl font-bold text-green-600">
//                 {insights.bestRound.score}
//               </p>
//               <p className="text-xs sm:text-sm text-green-700 truncate">
//                 {insights.bestRound.course}
//               </p>
//               <p className="text-xs text-green-600">
//                 {insights.bestRound.date}
//               </p>
//             </div>
//           )}

//           {insights.worstRound && (
//             <div className="bg-red-50 p-3 sm:p-4 rounded-lg border border-red-200">
//               <h4 className="font-semibold text-red-800 text-sm sm:text-base">
//                 Worst Round
//               </h4>
//               <p className="text-xl sm:text-2xl font-bold text-red-600">
//                 {insights.worstRound.score}
//               </p>
//               <p className="text-xs sm:text-sm text-red-700 truncate">
//                 {insights.worstRound.course}
//               </p>
//               <p className="text-xs text-red-600">{insights.worstRound.date}</p>
//             </div>
//           )}
//         </div>

//         {/* Consistency */}
//         {insights.consistency && (
//           <div className="space-y-3 sm:space-y-4">
//             <h3 className="text-base sm:text-lg font-semibold">
//               Consistency Analysis
//             </h3>
//             <div className="bg-blue-50 p-3 sm:p-4 rounded-lg border border-blue-200">
//               <div className="flex justify-between mb-2 text-sm sm:text-base">
//                 <span className="text-blue-700">Average Score:</span>
//                 <span className="font-semibold">
//                   {insights.consistency.averageScore}
//                 </span>
//               </div>
//               <div className="flex justify-between mb-2 text-sm sm:text-base">
//                 <span className="text-blue-700">Std Dev:</span>
//                 <span className="font-semibold">
//                   {insights.consistency.standardDeviation}
//                 </span>
//               </div>
//               <div className="flex justify-between text-sm sm:text-base">
//                 <span className="text-blue-700">Rating:</span>
//                 <span
//                   className={`font-semibold ${
//                     insights.consistency.consistencyRating === "Excellent"
//                       ? "text-green-600"
//                       : insights.consistency.consistencyRating === "Good"
//                       ? "text-yellow-600"
//                       : "text-red-600"
//                   }`}
//                 >
//                   {insights.consistency.consistencyRating}
//                 </span>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Strengths & Weaknesses Chart */}
//       {strengthsData.length > 0 && (
//         <div className="mt-4 sm:mt-6">
//           <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">
//             Strengths & Weaknesses
//           </h3>
//           <div className="bg-gray-50 p-3 sm:p-4 rounded-lg border">
//             <ResponsiveContainer width="100%" height={200}>
//               <BarChart data={strengthsData} layout="vertical">
//                 <CartesianGrid strokeDasharray="3 3" horizontal={false} />
//                 <XAxis type="number" domain={[0, 100]} fontSize={12} />
//                 <YAxis
//                   type="category"
//                   dataKey="category"
//                   fontSize={12}
//                   width={60}
//                 />
//                 <Tooltip formatter={(value) => [`${value}%`, "Rating"]} />
//                 <Bar dataKey="rating" name="Performance Rating">
//                   {strengthsData.map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={entry.color} />
//                   ))}
//                 </Bar>
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default GolfStatisticsDashboard;

// pages/GolfStatisticsDashboard.js
import { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import api from "../api/axiosInstance";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  Trophy,
  TrendingUp,
  Target,
  BarChart3,
  ChevronLeft,
  Calendar,
  Award,
  TrendingDown,
  Zap,
  Star,
  Filter,
  Download,
  Share2,
  RefreshCw,
  Eye,
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  Minus,
  CheckCircle,
  AlertCircle,
  Info,
} from "lucide-react";

const GolfStatisticsDashboard = () => {
  const [summary, setSummary] = useState(null);
  const [trends, setTrends] = useState(null);
  const [insights, setInsights] = useState(null);
  const [timeRange, setTimeRange] = useState(6);
  const [activeTab, setActiveTab] = useState("overview");
  const [loading, setLoading] = useState({
    summary: true,
    trends: true,
    insights: true,
  });

  const navigate = useNavigate();

  const COLORS = [
    "#10B981", // emerald
    "#3B82F6", // blue
    "#F59E0B", // amber
    "#8B5CF6", // violet
    "#EF4444", // red
    "#06B6D4", // cyan
  ];

  const CHART_GRADIENTS = [
    { from: "#10B981", to: "#34D399" }, // emerald
    { from: "#3B82F6", to: "#60A5FA" }, // blue
    { from: "#F59E0B", to: "#FBBF24" }, // amber
    { from: "#8B5CF6", to: "#A78BFA" }, // violet
  ];

  useEffect(() => {
    fetchSummary();
    fetchTrends(timeRange);
    fetchInsights();
  }, [timeRange]);

  const fetchSummary = async () => {
    try {
      setLoading((prev) => ({ ...prev, summary: true }));
      const response = await api.get("/golf-statistics/my-summary");
      setSummary(response.data);
    } catch (error) {
      console.error("Error fetching summary:", error);
      toast.error("Failed to load statistics summary");
    } finally {
      setLoading((prev) => ({ ...prev, summary: false }));
    }
  };

  const fetchTrends = async (months) => {
    try {
      setLoading((prev) => ({ ...prev, trends: true }));
      const response = await api.get(
        `/golf-statistics/historical-trends/${months}`
      );
      setTrends(response.data);
    } catch (error) {
      console.error("Error fetching trends:", error);
      toast.error("Failed to load trend data");
    } finally {
      setLoading((prev) => ({ ...prev, trends: false }));
    }
  };

  const fetchInsights = async () => {
    try {
      setLoading((prev) => ({ ...prev, insights: true }));
      const response = await api.get("/golf-statistics/performance-insights");
      setInsights(response.data);
    } catch (error) {
      console.error("Error fetching insights:", error);
      toast.error("Failed to load performance insights");
    } finally {
      setLoading((prev) => ({ ...prev, insights: false }));
    }
  };

  const prepareTrendData = () => {
    if (!trends) return [];

    const months = Object.keys(trends.scoreTrend || {});
    return months.map((month) => ({
      name: month.substring(0, 3),
      score: trends.scoreTrend[month] || 0,
      handicap: trends.handicapTrend[month] || 0,
      fairways: trends.fairwaysTrend[month] || 0,
      gir: trends.girTrend[month] || 0,
      putts: trends.puttingTrend[month] || 0,
    }));
  };

  const preparePerformanceData = () => {
    if (!trends) return [];

    const months = Object.keys(trends.scoreTrend || {});
    return months.map((month) => ({
      name: month.substring(0, 3),
      fairways: trends.fairwaysTrend[month] || 0,
      gir: trends.girTrend[month] || 0,
      putts: trends.puttingTrend[month] || 0,
    }));
  };

  const formatNumber = (num) => {
    if (!num && num !== 0) return "N/A";
    return typeof num === "number" ? num.toFixed(1) : num;
  };

  const getTrendDirection = (current, previous) => {
    if (!current || !previous) return "neutral";
    if (current < previous) return "up";
    if (current > previous) return "down";
    return "neutral";
  };

  const getTrendIcon = (direction) => {
    switch (direction) {
      case "up":
        return <TrendingUpIcon className="w-4 h-4 text-emerald-500" />;
      case "down":
        return <TrendingDownIcon className="w-4 h-4 text-red-500" />;
      default:
        return <Minus className="w-4 h-4 text-gray-500" />;
    }
  };

  if (loading.summary) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-30"></div>
            <div className="relative w-16 h-16 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
          </div>
          <p className="mt-6 text-gray-600 font-medium">
            Loading your golf statistics...
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Analyzing your performance data
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50">
      {/* Header */}
      <div className="sticky top-0 z-10 bg-gradient-to-r from-emerald-900 via-emerald-800 to-lime-800 text-white shadow-xl">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="py-6">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                <button
                  onClick={() => navigate("/dashboard")}
                  className="flex items-center gap-2 text-emerald-200 hover:text-white transition-colors group"
                >
                  <ChevronLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
                  <span className="hidden sm:inline">Back to Dashboard</span>
                </button>
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500/20 to-lime-500/20 backdrop-blur-sm border border-emerald-400/30 flex items-center justify-center">
                      <BarChart3 className="w-5 h-5 text-emerald-300" />
                    </div>
                    <div>
                      <h1 className="text-2xl md:text-3xl font-bold">
                        Golf Analytics
                      </h1>
                      <p className="text-emerald-200 text-sm md:text-base">
                        Track and analyze your golf performance
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={() => {
                    fetchSummary();
                    fetchTrends(timeRange);
                    fetchInsights();
                  }}
                  className="px-4 py-2 rounded-xl bg-emerald-700 hover:bg-emerald-600 transition-colors flex items-center gap-2"
                >
                  <RefreshCw className="w-4 h-4" />
                  <span className="hidden sm:inline">Refresh</span>
                </button>
                <select
                  value={timeRange}
                  onChange={(e) => setTimeRange(parseInt(e.target.value))}
                  className="bg-emerald-800 border border-emerald-700 rounded-xl px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500"
                >
                  <option value={3}>Last 3 Months</option>
                  <option value={6}>Last 6 Months</option>
                  <option value={12}>Last 12 Months</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-8">
        {/* Quick Stats */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-emerald-100 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-50 to-cyan-50 flex items-center justify-center">
                <Target className="w-6 h-6 text-blue-600" />
              </div>
              <div className="text-sm text-blue-600 font-semibold bg-blue-50 px-3 py-1 rounded-full">
                Scoring
              </div>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-2">
              {formatNumber(summary?.averages?.scoring)}
            </p>
            <p className="text-sm text-gray-600">Average Score</p>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-emerald-100 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center">
                <TrendingUp className="w-6 h-6 text-emerald-600" />
              </div>
              <div className="text-sm text-emerald-600 font-semibold bg-emerald-50 px-3 py-1 rounded-full">
                Index
              </div>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-2">
              {formatNumber(summary?.averages?.handicap)}
            </p>
            <p className="text-sm text-gray-600">Handicap Index</p>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-emerald-100 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center">
                <Calendar className="w-6 h-6 text-purple-600" />
              </div>
              <div className="text-sm text-purple-600 font-semibold bg-purple-50 px-3 py-1 rounded-full">
                Activity
              </div>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-2">
              {summary?.totalRounds || 0}
            </p>
            <p className="text-sm text-gray-600">Total Rounds</p>
          </div>

          <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 border border-emerald-100 shadow-lg hover:shadow-xl transition-all duration-300 group">
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-50 to-orange-50 flex items-center justify-center">
                <Trophy className="w-6 h-6 text-amber-600" />
              </div>
              <div className="text-sm text-amber-600 font-semibold bg-amber-50 px-3 py-1 rounded-full">
                Latest
              </div>
            </div>
            <p className="text-3xl font-bold text-gray-900 mb-1">
              {summary?.latestRound?.score || "N/A"}
            </p>
            <p className="text-sm text-gray-500 truncate">
              {summary?.latestRound?.course || "No recent rounds"}
            </p>
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="mb-6 md:mb-8">
          <div className="flex flex-wrap gap-2">
            {[
              {
                id: "overview",
                label: "Overview",
                icon: <Eye className="w-4 h-4" />,
              },
              {
                id: "trends",
                label: "Trends",
                icon: <TrendingUp className="w-4 h-4" />,
              },
              {
                id: "insights",
                label: "Insights",
                icon: <Zap className="w-4 h-4" />,
              },
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-2 px-6 py-3 rounded-xl font-medium transition-all duration-300 ${
                  activeTab === tab.id
                    ? "bg-gradient-to-r from-emerald-500 to-lime-500 text-white shadow-lg transform -translate-y-0.5"
                    : "bg-white text-gray-700 hover:bg-gray-50 shadow-md hover:shadow-lg border border-gray-100"
                }`}
              >
                {tab.icon}
                <span>{tab.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-6 md:p-8 border border-emerald-100">
          {activeTab === "overview" && (
            <OverviewTab
              summary={summary}
              loading={loading}
              COLORS={COLORS}
              CHART_GRADIENTS={CHART_GRADIENTS}
            />
          )}
          {activeTab === "trends" && (
            <TrendsTab
              trends={trends}
              timeRange={timeRange}
              setTimeRange={setTimeRange}
              loading={loading}
              COLORS={COLORS}
              CHART_GRADIENTS={CHART_GRADIENTS}
              prepareTrendData={prepareTrendData}
              preparePerformanceData={preparePerformanceData}
              getTrendDirection={getTrendDirection}
              getTrendIcon={getTrendIcon}
            />
          )}
          {activeTab === "insights" && (
            <InsightsTab
              insights={insights}
              loading={loading}
              COLORS={COLORS}
              getTrendDirection={getTrendDirection}
              getTrendIcon={getTrendIcon}
            />
          )}
        </div>
      </main>
    </div>
  );
};

const OverviewTab = ({ summary, loading, COLORS, CHART_GRADIENTS }) => {
  if (loading.summary) {
    return (
      <div className="text-center py-12">
        <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
      </div>
    );
  }

  if (!summary || summary.message) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mx-auto mb-4">
          <Target className="w-8 h-8 text-emerald-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          No Statistics Available
        </h3>
        <p className="text-gray-600 max-w-md mx-auto mb-6">
          Start tracking your golf rounds to see detailed statistics and
          insights.
        </p>
        <button className="px-6 py-3 rounded-xl bg-gradient-to-r from-emerald-500 to-lime-500 text-white font-semibold hover:shadow-lg transition-all duration-300">
          Add Your First Round
        </button>
      </div>
    );
  }

  const scoringDistribution =
    summary.recentRounds && summary.recentRounds[0]
      ? [
          {
            name: "Eagles",
            value: summary.recentRounds[0].eagles || 0,
            color: COLORS[0],
          },
          {
            name: "Birdies",
            value: summary.recentRounds[0].birdies || 0,
            color: COLORS[1],
          },
          {
            name: "Pars",
            value: summary.recentRounds[0].pars || 0,
            color: COLORS[2],
          },
          {
            name: "Bogeys",
            value: summary.recentRounds[0].bogeys || 0,
            color: COLORS[3],
          },
          {
            name: "Double+",
            value: summary.recentRounds[0].doubleBogeys || 0,
            color: COLORS[4],
          },
        ]
      : [];

  const puttingData = summary.recentRounds
    ? summary.recentRounds.map((round, index) => ({
        name: `R${index + 1}`,
        putts: round.totalPutts || 0,
        score: round.totalScore || 0,
      }))
    : [];

  return (
    <div className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Performance Overview
          </h2>
          <p className="text-gray-600">
            Your recent performance metrics and trends
          </p>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-500">
          <Calendar className="w-4 h-4" />
          <span>Last {summary.recentRounds?.length || 0} rounds</span>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        {/* Scoring Distribution */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">
              Scoring Distribution
            </h3>
            <div className="text-sm text-emerald-600 bg-emerald-50 px-3 py-1 rounded-full">
              Per Round
            </div>
          </div>
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-100">
            {scoringDistribution.length > 0 ? (
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={scoringDistribution}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={({ name, percent }) =>
                      `${name}: ${(percent * 100).toFixed(0)}%`
                    }
                    outerRadius={100}
                    innerRadius={40}
                    dataKey="value"
                  >
                    {scoringDistribution.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip
                    formatter={(value) => [`${value} shots`, "Count"]}
                    contentStyle={{
                      borderRadius: "8px",
                      border: "1px solid #e5e7eb",
                      background: "white",
                      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  <Legend
                    wrapperStyle={{ fontSize: "13px", marginTop: "20px" }}
                  />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-12">
                <Target className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                <p className="text-gray-500">No scoring data available</p>
              </div>
            )}
          </div>
        </div>

        {/* Putting Performance */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">
              Putting Performance
            </h3>
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Target className="w-4 h-4" />
              <span>Trend Analysis</span>
            </div>
          </div>
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-100">
            {puttingData.length > 0 ? (
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={puttingData}>
                  <defs>
                    <linearGradient id="colorPutts" x1="0" y1="0" x2="0" y2="1">
                      <stop
                        offset="5%"
                        stopColor={CHART_GRADIENTS[0].from}
                        stopOpacity={0.8}
                      />
                      <stop
                        offset="95%"
                        stopColor={CHART_GRADIENTS[0].to}
                        stopOpacity={0.2}
                      />
                    </linearGradient>
                    <linearGradient id="colorScore" x1="0" y1="0" x2="0" y2="1">
                      <stop
                        offset="5%"
                        stopColor={CHART_GRADIENTS[1].from}
                        stopOpacity={0.8}
                      />
                      <stop
                        offset="95%"
                        stopColor={CHART_GRADIENTS[1].to}
                        stopOpacity={0.2}
                      />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                  <XAxis dataKey="name" stroke="#6b7280" fontSize={12} />
                  <YAxis stroke="#6b7280" fontSize={12} />
                  <Tooltip
                    contentStyle={{
                      borderRadius: "8px",
                      border: "1px solid #e5e7eb",
                      background: "white",
                      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  <Legend
                    wrapperStyle={{ fontSize: "13px", marginTop: "10px" }}
                  />
                  <Bar
                    dataKey="putts"
                    name="Total Putts"
                    fill="url(#colorPutts)"
                    radius={[4, 4, 0, 0]}
                  />
                  <Bar
                    dataKey="score"
                    name="Total Score"
                    fill="url(#colorScore)"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-12">
                <TrendingUp className="w-12 h-12 text-gray-300 mx-auto mb-3" />
                <p className="text-gray-500">No putting data available</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Recent Rounds */}
      {summary.recentRounds && summary.recentRounds.length > 0 && (
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold text-gray-900">
              Recent Rounds
            </h3>
            <button className="text-sm text-emerald-600 hover:text-emerald-800 font-medium flex items-center gap-2">
              View All
              <ChevronLeft className="w-4 h-4 rotate-180" />
            </button>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {summary.recentRounds.slice(0, 3).map((round, index) => (
              <div
                key={index}
                className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-5 border border-gray-100 hover:border-emerald-200 transition-all duration-300 group hover:shadow-lg"
              >
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h4 className="font-bold text-gray-900 truncate">
                      {round.courseName || `Round ${index + 1}`}
                    </h4>
                    <p className="text-sm text-gray-500">{round.roundDate}</p>
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-emerald-600">
                      {round.totalScore}
                    </div>
                    <div className="text-xs text-gray-500">Total Score</div>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-3 text-center">
                  <div>
                    <div className="text-lg font-bold text-blue-600">
                      {round.handicapIndex || "-"}
                    </div>
                    <div className="text-xs text-gray-500">Handicap</div>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-purple-600">
                      {round.totalPutts || "-"}
                    </div>
                    <div className="text-xs text-gray-500">Putts</div>
                  </div>
                  <div>
                    <div className="text-lg font-bold text-amber-600">
                      {round.fairwaysHit && round.fairwaysPossible
                        ? `${Math.round(
                            (round.fairwaysHit / round.fairwaysPossible) * 100
                          )}%`
                        : "-"}
                    </div>
                    <div className="text-xs text-gray-500">Fairways</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const TrendsTab = ({
  trends,
  timeRange,
  setTimeRange,
  loading,
  COLORS,
  CHART_GRADIENTS,
  prepareTrendData,
  preparePerformanceData,
  getTrendDirection,
  getTrendIcon,
}) => {
  const trendData = prepareTrendData();
  const performanceData = preparePerformanceData();

  if (loading.trends) {
    return (
      <div className="text-center py-12">
        <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
      </div>
    );
  }

  const currentScore = trendData[trendData.length - 1]?.score;
  const previousScore = trendData[trendData.length - 2]?.score;
  const scoreTrend = getTrendDirection(currentScore, previousScore);

  const currentHandicap = trendData[trendData.length - 1]?.handicap;
  const previousHandicap = trendData[trendData.length - 2]?.handicap;
  const handicapTrend = getTrendDirection(currentHandicap, previousHandicap);

  return (
    <div className="space-y-8">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">
            Performance Trends
          </h2>
          <p className="text-gray-600">Analyze your performance over time</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="bg-gray-100 rounded-xl px-4 py-2">
            <div className="flex items-center gap-2 text-sm">
              <Filter className="w-4 h-4 text-gray-500" />
              <select
                value={timeRange}
                onChange={(e) => setTimeRange(parseInt(e.target.value))}
                className="bg-transparent focus:outline-none text-gray-700"
              >
                <option value={3}>Last 3 Months</option>
                <option value={6}>Last 6 Months</option>
                <option value={12}>Last 12 Months</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {trendData.length > 0 ? (
        <>
          {/* Quick Trends Summary */}
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-100">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
                    <Target className="w-5 h-5 text-blue-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Score Trend</h4>
                    <p className="text-sm text-gray-600">Latest vs Previous</p>
                  </div>
                </div>
                {getTrendIcon(scoreTrend)}
              </div>
              <div className="flex items-end gap-2">
                <div className="text-3xl font-bold text-gray-900">
                  {formatNumber(currentScore)}
                </div>
                <div className="text-sm text-gray-500 mb-1">
                  {previousScore
                    ? `from ${formatNumber(previousScore)}`
                    : "No previous data"}
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-lime-50 rounded-xl p-6 border border-emerald-100">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center">
                    <TrendingUp className="w-5 h-5 text-emerald-600" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">
                      Handicap Trend
                    </h4>
                    <p className="text-sm text-gray-600">Latest vs Previous</p>
                  </div>
                </div>
                {getTrendIcon(handicapTrend)}
              </div>
              <div className="flex items-end gap-2">
                <div className="text-3xl font-bold text-gray-900">
                  {formatNumber(currentHandicap)}
                </div>
                <div className="text-sm text-gray-500 mb-1">
                  {previousHandicap
                    ? `from ${formatNumber(previousHandicap)}`
                    : "No previous data"}
                </div>
              </div>
            </div>
          </div>

          {/* Charts Grid */}
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Score Trend Chart */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                Score Progression
              </h3>
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-100">
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={trendData}>
                    <defs>
                      <linearGradient
                        id="colorScoreLine"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="5%"
                          stopColor={CHART_GRADIENTS[0].from}
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor={CHART_GRADIENTS[0].to}
                          stopOpacity={0.1}
                        />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="name" stroke="#6b7280" fontSize={12} />
                    <YAxis stroke="#6b7280" fontSize={12} />
                    <Tooltip
                      contentStyle={{
                        borderRadius: "8px",
                        border: "1px solid #e5e7eb",
                        background: "white",
                        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                      }}
                    />
                    <Legend
                      wrapperStyle={{ fontSize: "13px", marginTop: "10px" }}
                    />
                    <Line
                      type="monotone"
                      dataKey="score"
                      stroke={`url(#colorScoreLine)`}
                      strokeWidth={3}
                      dot={{
                        fill: CHART_GRADIENTS[0].from,
                        strokeWidth: 2,
                        r: 4,
                      }}
                      activeDot={{ r: 6, fill: CHART_GRADIENTS[0].from }}
                      name="Average Score"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            {/* Handicap Trend Chart */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                Handicap Evolution
              </h3>
              <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-100">
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={trendData}>
                    <defs>
                      <linearGradient
                        id="colorHandicapLine"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="5%"
                          stopColor={CHART_GRADIENTS[1].from}
                          stopOpacity={0.8}
                        />
                        <stop
                          offset="95%"
                          stopColor={CHART_GRADIENTS[1].to}
                          stopOpacity={0.1}
                        />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                    <XAxis dataKey="name" stroke="#6b7280" fontSize={12} />
                    <YAxis stroke="#6b7280" fontSize={12} />
                    <Tooltip
                      contentStyle={{
                        borderRadius: "8px",
                        border: "1px solid #e5e7eb",
                        background: "white",
                        boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                      }}
                    />
                    <Legend
                      wrapperStyle={{ fontSize: "13px", marginTop: "10px" }}
                    />
                    <Line
                      type="monotone"
                      dataKey="handicap"
                      stroke={`url(#colorHandicapLine)`}
                      strokeWidth={3}
                      dot={{
                        fill: CHART_GRADIENTS[1].from,
                        strokeWidth: 2,
                        r: 4,
                      }}
                      activeDot={{ r: 6, fill: CHART_GRADIENTS[1].from }}
                      name="Handicap Index"
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>
          </div>

          {/* Performance Metrics */}
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-900">Key Metrics</h3>
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-100">
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={performanceData}>
                  <defs>
                    <linearGradient
                      id="colorFairways"
                      x1="0"
                      y1="0"
                      x2="0"
                      y2="1"
                    >
                      <stop
                        offset="5%"
                        stopColor={CHART_GRADIENTS[2].from}
                        stopOpacity={0.8}
                      />
                      <stop
                        offset="95%"
                        stopColor={CHART_GRADIENTS[2].to}
                        stopOpacity={0.2}
                      />
                    </linearGradient>
                    <linearGradient id="colorGIR" x1="0" y1="0" x2="0" y2="1">
                      <stop
                        offset="5%"
                        stopColor={CHART_GRADIENTS[3].from}
                        stopOpacity={0.8}
                      />
                      <stop
                        offset="95%"
                        stopColor={CHART_GRADIENTS[3].to}
                        stopOpacity={0.2}
                      />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
                  <XAxis dataKey="name" stroke="#6b7280" fontSize={12} />
                  <YAxis stroke="#6b7280" fontSize={12} />
                  <Tooltip
                    formatter={(value) => [`${value}%`, "Percentage"]}
                    contentStyle={{
                      borderRadius: "8px",
                      border: "1px solid #e5e7eb",
                      background: "white",
                      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                  <Legend
                    wrapperStyle={{ fontSize: "13px", marginTop: "10px" }}
                  />
                  <Bar
                    dataKey="fairways"
                    name="Fairways %"
                    fill="url(#colorFairways)"
                    radius={[4, 4, 0, 0]}
                  />
                  <Bar
                    dataKey="gir"
                    name="GIR %"
                    fill="url(#colorGIR)"
                    radius={[4, 4, 0, 0]}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </>
      ) : (
        <div className="text-center py-12">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mx-auto mb-4">
            <TrendingUp className="w-8 h-8 text-emerald-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            No Trend Data Available
          </h3>
          <p className="text-gray-600 max-w-md mx-auto">
            Add more rounds over time to see performance trends and insights.
          </p>
        </div>
      )}
    </div>
  );
};

const InsightsTab = ({
  insights,
  loading,
  COLORS,
  getTrendDirection,
  getTrendIcon,
}) => {
  if (loading.insights) {
    return (
      <div className="text-center py-12">
        <div className="w-8 h-8 border-2 border-emerald-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
      </div>
    );
  }

  if (!insights || insights.message) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 flex items-center justify-center mx-auto mb-4">
          <Zap className="w-8 h-8 text-emerald-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-900 mb-2">
          No Insights Available
        </h3>
        <p className="text-gray-600 max-w-md mx-auto mb-6">
          Add more rounds to get detailed performance insights and
          recommendations.
        </p>
      </div>
    );
  }

  const strengthsData = insights.strengthsWeaknesses
    ? Object.entries(insights.strengthsWeaknesses).map(
        ([category, rating]) => ({
          category:
            category.length > 12 ? category.substring(0, 12) + "..." : category,
          rating:
            rating === "Excellent"
              ? 95
              : rating === "Good"
              ? 75
              : rating === "Average"
              ? 50
              : 25,
          color:
            rating === "Excellent"
              ? COLORS[1]
              : rating === "Good"
              ? COLORS[2]
              : rating === "Average"
              ? COLORS[3]
              : COLORS[4],
          icon:
            rating === "Excellent" ? (
              <Star className="w-4 h-4" />
            ) : rating === "Good" ? (
              <CheckCircle className="w-4 h-4" />
            ) : (
              <AlertCircle className="w-4 h-4" />
            ),
        })
      )
    : [];

  return (
    <div className="space-y-8">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">
          Performance Insights
        </h2>
        <p className="text-gray-600">AI-powered analysis of your golf game</p>
      </div>

      <div className="grid lg:grid-cols-2 gap-8">
        {/* Best & Worst Rounds */}
        <div className="space-y-6">
          <h3 className="text-lg font-semibold text-gray-900">
            Round Highlights
          </h3>

          {insights.bestRound && (
            <div className="bg-gradient-to-br from-emerald-50 to-lime-50 rounded-xl p-6 border border-emerald-100 group hover:shadow-lg transition-all duration-300">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-emerald-500 to-lime-500 flex items-center justify-center">
                  <Trophy className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Best Round</h4>
                  <p className="text-sm text-emerald-600">Personal record</p>
                </div>
              </div>
              <div className="flex items-end justify-between">
                <div>
                  <div className="text-3xl font-bold text-gray-900">
                    {insights.bestRound.score}
                  </div>
                  <p className="text-sm text-gray-600 truncate">
                    {insights.bestRound.course}
                  </p>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-500">Date</div>
                  <div className="font-medium text-gray-700">
                    {insights.bestRound.date}
                  </div>
                </div>
              </div>
            </div>
          )}

          {insights.worstRound && (
            <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-xl p-6 border border-red-100 group hover:shadow-lg transition-all duration-300">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-red-500 to-rose-500 flex items-center justify-center">
                  <Target className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">Improvement Focus</h4>
                  <p className="text-sm text-red-600">Learn from challenges</p>
                </div>
              </div>
              <div className="flex items-end justify-between">
                <div>
                  <div className="text-3xl font-bold text-gray-900">
                    {insights.worstRound.score}
                  </div>
                  <p className="text-sm text-gray-600 truncate">
                    {insights.worstRound.course}
                  </p>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-500">Date</div>
                  <div className="font-medium text-gray-700">
                    {insights.worstRound.date}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Consistency Analysis */}
        {insights.consistency && (
          <div className="space-y-6">
            <h3 className="text-lg font-semibold text-gray-900">
              Consistency Analysis
            </h3>
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 border border-blue-100">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-lg bg-gradient-to-r from-blue-500 to-cyan-500 flex items-center justify-center">
                  <TrendingUp className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-gray-900">
                    Performance Consistency
                  </h4>
                  <p className="text-sm text-blue-600">
                    Stability in your game
                  </p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Average Score</span>
                  <span className="font-bold text-gray-900">
                    {insights.consistency.averageScore}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-gray-700">Standard Deviation</span>
                  <span className="font-bold text-gray-900">
                    {insights.consistency.standardDeviation}
                  </span>
                </div>
                <div className="flex justify-between items-center pt-4 border-t border-blue-200">
                  <span className="text-gray-700">Consistency Rating</span>
                  <span
                    className={`px-3 py-1 rounded-full font-medium ${
                      insights.consistency.consistencyRating === "Excellent"
                        ? "bg-emerald-100 text-emerald-700"
                        : insights.consistency.consistencyRating === "Good"
                        ? "bg-blue-100 text-blue-700"
                        : insights.consistency.consistencyRating === "Average"
                        ? "bg-amber-100 text-amber-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {insights.consistency.consistencyRating}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Strengths & Weaknesses */}
      {strengthsData.length > 0 && (
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Areas of Focus
          </h3>
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-6 border border-gray-100">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {strengthsData.map((item, index) => (
                <div
                  key={index}
                  className="bg-white rounded-lg p-4 border border-gray-200 hover:border-emerald-200 transition-all duration-300"
                >
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center gap-2">
                      <div
                        className={`w-8 h-8 rounded-full flex items-center justify-center ${
                          item.rating >= 75
                            ? "bg-emerald-100 text-emerald-600"
                            : item.rating >= 50
                            ? "bg-blue-100 text-blue-600"
                            : "bg-amber-100 text-amber-600"
                        }`}
                      >
                        {item.icon}
                      </div>
                      <span className="font-medium text-gray-900">
                        {item.category}
                      </span>
                    </div>
                    <div
                      className="text-lg font-bold"
                      style={{ color: item.color }}
                    >
                      {item.rating}%
                    </div>
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="h-2 rounded-full transition-all duration-500"
                      style={{
                        width: `${item.rating}%`,
                        backgroundColor: item.color,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Recommendations */}
      {insights.recommendations && insights.recommendations.length > 0 && (
        <div className="space-y-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Personalized Recommendations
          </h3>
          <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 border border-purple-100">
            <div className="flex items-center gap-3 mb-4">
              <Info className="w-6 h-6 text-purple-600" />
              <h4 className="font-bold text-gray-900">Improvement Tips</h4>
            </div>
            <ul className="space-y-3">
              {insights.recommendations.slice(0, 3).map((rec, index) => (
                <li key={index} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-white flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                  </div>
                  <span className="text-gray-700">{rec}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

// Helper function to format numbers
const formatNumber = (num) => {
  if (!num && num !== 0) return "N/A";
  return typeof num === "number" ? num.toFixed(1) : num;
};

export default GolfStatisticsDashboard;
